module.exports = __webpack_public_path__ + "img/finance2.9bef6360.png";